import React from 'react';
import { NextSeo } from 'next-seo';

const SEO = {
    NAME: 'Bumble Night In',
    TITLE: 'Think you’ve got game?',
    DESCRIPTION: 'A better way to date in virtually every way',
    URL: 'https://bumble.com/night-in',
    IMAGE_ALT: 'Bumble Night In',
};

const PageCEO: React.FC<React.PropsWithChildren> = () => {
    const [imageUrl, setImageUrl] = React.useState('/night-in/social-sharing.jpg');

    React.useEffect(() => {
        if (global.window.innerHeight) {
            setImageUrl(`${global.window.location.origin}/night-in/social-sharing.jpg`);
        }
    }, [setImageUrl]);

    return (
        <NextSeo
            title={SEO.NAME}
            description={SEO.DESCRIPTION}
            canonical={SEO.URL}
            openGraph={{
                url: SEO.URL,
                title: SEO.TITLE,
                description: SEO.DESCRIPTION,
                images: [
                    {
                        url: imageUrl,
                        width: 1200,
                        height: 630,
                        alt: SEO.IMAGE_ALT,
                    },
                ],
                site_name: SEO.NAME,
            }}
            twitter={{
                handle: '@handle',
                site: '@site',
                cardType: 'summary_large_image',
            }}
        />
    );
};

export default PageCEO;
